// Single source of truth for "Learn" hub articles.
// Add new entries here and they automatically render in:
//  - the landing-page LearnHub section
//  - the /learn/<slug> route
//
// Each entry's `Component` is a default-exported React component holding the
// article body. Hero/share metadata stays in this file so card rendering and
// SEO stay decoupled from prose.

import HowGstWorks from "../articles/HowGstWorks";
import GstForGoldTraders from "../articles/GstForGoldTraders";
import FairTradingProfit from "../articles/FairTradingProfit";

export const ARTICLES = [
  {
    slug: "how-gst-works",
    Component: HowGstWorks,
    category: "Tax 101",
    title: "How GST really works — and who actually pays it",
    headline: ["How GST really works —", "and who actually pays it."],
    description:
      "A plain-English explainer for sole traders, tradies, and commission earners. If you've ever felt like GST is eating your income, this clears it up in 5 minutes.",
    readMinutes: 5,
    publishedOn: "2026-02-15",
    heroKicker: "Tax 101 · Plain English",
    socialDescription:
      "GST isn't your cost — it's your customer's. Here's the 5-minute explainer that ends the confusion for tradies, agents, and sole traders.",
  },
  {
    slug: "gst-for-gold-traders",
    Component: GstForGoldTraders,
    category: "Niche guide · Gold dealers",
    title: "GST for gold traders — why some gold has NO GST and some has 15%",
    headline: ["GST for gold traders —", "why some has NO GST and some has 15%."],
    description:
      "Built for gold buyers, pawnbrokers, jewellers, and bullion dealers. The single rule that fixes 90% of GST confusion in this niche — and the second-hand trap that catches almost everyone.",
    readMinutes: 6,
    publishedOn: "2026-02-22",
    heroKicker: "Niche guide · Gold & jewellery",
    socialDescription:
      "Why bullion has NO GST but jewellery has 15% — and why getting it wrong eats your margin. A 6-minute read for NZ gold buyers, pawnbrokers, and bullion dealers.",
  },
  {
    slug: "fair-trading-makes-you-money",
    Component: FairTradingProfit,
    category: "Strategy",
    title: "Why fair trading makes you more money (not less)",
    headline: ["Why fair trading makes you", "more money — not less."],
    description:
      "Most NZ business owners treat fair trading as a compliance tax. The smart ones treat it as a profit lever. Here's the maths nobody runs — and the 3 system fixes that turn honesty into recurring revenue.",
    readMinutes: 5,
    publishedOn: "2026-03-02",
    heroKicker: "Strategy · NZ small business",
    socialDescription:
      'If you trade fairly, customers pay you once. If you build trust, they pay you for years. The 5-minute read every NZ business owner should run their pricing through.',
  },
];

export function findArticle(slug) {
  return ARTICLES.find((a) => a.slug === slug);
}
